export function getView(state) {
  switch (state) {
    case 'SCHEDULED':
      return 'Scheduled'
    case 'CONFIRMED':
      return 'Confirmed'
    case 'OFFICE_CANCELLED':
    case 'PATIENT_CANCELLED':
      return 'Cancelled'
    case 'NO_SHOW':
      return 'NoShow'
    case 'UNSEATED':
      return 'Unseated'
    case 'CHECKED_OUT':
      return 'CheckedOut'
    default:
      return 'No'
  }
}
